/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PracticeList } from './practiceList';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedPracticeListList { 
    next?: string | null;
    previous?: string | null;
    results: Array<PracticeList>;
}
export const PaginatedPracticeListList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedPracticeListList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedPracticeListList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


